var t = function (str, obj) {
    if (window === null || window === void 0 ? void 0 : window.i18n) {
        if (obj) {
            if (obj.count !== undefined) {
                return window.i18n.interpolate(window.i18n.ngettext(str, str, obj.count), obj, true);
            }
            else {
                return window.i18n.interpolate(window.i18n.gettext(str), obj, true);
            }
        }
        else {
            return window.i18n.gettext(str);
        }
    }
    else {
        return str;
    }
};
var x = function (str) {
    if (window === null || window === void 0 ? void 0 : window.i18n) {
        return window.i18n.gettext(str);
    }
    else {
        return str;
    }
};
var localization = {
    t: t,
    x: x,
};

export { localization as default, t, x };
//# sourceMappingURL=localization.js.map
